<template>
  <div class="settings-modal default-modal">
    <div class="default-modal__header">
      <button type="button" class="default-modal__close settings-modal__close" @click="$emit('closeAll')">
        <IconComponent name="close" />
      </button>
      <h4 class="default-modal__title">Изменение персональных данных</h4>
    </div>
    <div class="default-modal__body">
      <!--      <div class="settings-modal__avatar">-->
      <!--        <ImgComponent />-->
      <!--        <InputComponent v-model="form.name.value" :errors="form.name.errors" placeholder="Имя" />-->
      <!--        <InputComponent v-model="form.surname.value" :errors="form.surname.errors" placeholder="Фамилия" />-->
      <!--      </div>-->
      <div class="settings-modal__inputs">
        <InputComponent v-model="form.name.value" :errors="form.name.errors" placeholder="Имя" />
        <InputComponent v-model="form.surname.value" :errors="form.surname.errors" placeholder="Фамилия" />
        <InputComponent
          v-model="form.birthday.value"
          :errors="form.birthday.errors"
          placeholder="Дата рождения"
          mask="##.##.####"
        />
        <InputComponent
          v-model="form.phone.value"
          :errors="form.phone.errors"
          placeholder="Номер телефона"
          mask="+7 (###) ###-##-##"
        />
        <InputComponent
          v-model="form.email.value"
          :errors="form.email.errors"
          placeholder="Электронная почта"
          type="email"
        />
        <div class="settings-modal__footer">
          <button @click.prevent="logout" class="btn btn--gray">
            <span>Выйти</span>
          </button>
          <button @click.prevent="submit" class="btn btn--black">
            <IconComponent v-if="loading" name="loading" />
            <span v-else>Изменить данные</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
// import ImgComponent from "components/ImgComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import POST from "@/graphql/auth/UserProfileEdit.graphql";

export default {
  name: "SettingsModal",
  components: { InputComponent, IconComponent },
  data() {
    return {
      loading: false,
      form: {
        name: {
          value: null,
          errors: [],
        },
        surname: {
          value: null,
          errors: [],
        },
        birthday: {
          value: null,
          errors: [],
        },
        email: {
          value: null,
          errors: [],
        },
        phone: {
          value: null,
          errors: [],
        },
        head_img: {
          value: null,
          errors: [],
        },
      },
    };
  },
  mounted() {
    this.form.name.value = this.user.name || undefined;
    this.form.surname.value = this.user.surname || undefined;
    this.form.email.value = this.user.email || undefined;
    this.form.phone.value = this.user.phone || undefined;
    this.form.birthday.value = this.user.birthday
      ? this.user.birthday.split(" ")[0].split("-").reverse().join(".")
      : undefined;
  },
  methods: {
    resetErrors() {
      Object.keys(this.form).forEach((key) => {
        this.form[key].errors = [];
      });
    },
    formatBirthday() {
      return this.form.birthday.value.split(".").reverse().join("-") + " 00:00:00";
    },
    submit() {
      this.loading = true;
      this.resetErrors();
      this.$apollo
        .mutate({
          mutation: POST,
          context: {
            headers: {
              Authorization: "Bearer " + this.$store.state.apollo_token,
            },
          },
          variables: {
            name: this.form.name.value,
            surname: this.form.surname.value,
            birthday: this.form.birthday.value ? this.formatBirthday() : undefined,
            phone: this.form.phone.value,
            email: this.form.email.value,
          },
        })
        .then(() => {
          this.loading = false;
          this.$store.state._modals = [];
          let apollo = this.$apollo.provider;
          this.$store.dispatch("USER", {
            apollo,
          });
        })
        .catch(({ graphQLErrors }) => {
          this.parseGqlErrors(graphQLErrors);
          this.loading = false;
        });
    },
    logout() {
      if (confirm("Вы уверены?")) {
        this.$store.state.apollo_token = undefined;
        this.$store.state.auth.user = null;
        require(["axios"], (axios) => {
          axios.default({
            method: "post",
            url: "/token",
            data: {
              token: null,
            },
            headers: {
              "Content-Type": "application/json",
            },
          });
        }).then(() => {
          this.$router.push({ name: "home" });
        });
      }
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].errors.push(err.extensions.validation[key][0]);
            }
          });
        }
      });
    },
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style lang="stylus">
.settings-modal {
  width 100%
  max-width 545px

  &__avatar {
    display: grid;
    grid-template-columns: 130fr 330fr;
    grid-template-rows: repeat(2, 1fr);
    gap 20px

    img {
      grid-area: 1 / 1 / 3 / 2;
    }
  }

  &__inputs {
    display flex
    flex-direction column
    gap 20px
    width 100%
  }

  .input {
    width: 100%;
  }

  .btn {
    height 46px
  }

  &__footer {
    display flex
    justify-content space-between

    & .btn:nth-child(1) {
      width 100%
      max-width 120px
    }

    & .btn:nth-child(2) {
      width 100%
      max-width 180px
    }
  }
}
</style>
